const doc = [({"ja":({"adminConstantHotelPriceUpdateType":({"absolute":"価格を設定する", "relative":"元の価格を調整する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;